import React, { useContext } from 'react'

import {motion} from 'framer-motion'

import StateContext from '../../StateContext'
import { firestore } from '../../firebase'
import usePrivateFirestore from '../../hooks/usePrivateFirestore'

function ImageGridPrivate({setSelectedImg, authorId, setProfileImage}) {

    const appState = useContext(StateContext)

    const { docs } = usePrivateFirestore('images', authorId)

    async function deleteHandler(e, imageId) {

        try {
            const imageRef = firestore.collection("authors").doc(authorId).collection("images")
            imageRef.delete()
        } catch (error) {
            
        }

    }

    return (
        <div className="img-grid">
            {docs && docs.map((doc, index) => {
                return (
                    <>
                    <motion.div 
                        className="image-wrap" 
                        key={index} 
                        onClick={() => setProfileImage(doc.imageUrl)}
                        layout
                        whileHover={{ opacity: 1 }}
                    >
                        <motion.img 
                            src={doc.imageUrl} 
                            alt={doc.imageUrl}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }} 
                            transition={{ delay: 1 }}
                        />
                        {appState.loggedIn && (
                            <div>
                                <button onClick={e => deleteHandler(e, doc.id)} className="btn btn-sm btn-danger">
                                    <i className="fas fa-trash"></i> Slett bilde
                                </button>
                            </div>
                        )}
                    </motion.div>
                    </>
                )
            })}
        </div>
    )
}
export default ImageGridPrivate